import { useState } from 'react'
import { useAuthedFetch } from '../auth/useAuthedFetch'
import { getMD5hash } from '../libs/crypto'

export const useFetchPOD = () => {
  const authedFetch = useAuthedFetch()
  const [isLoading, setIsLoading] = useState(false)

  const fetchPOD = async shippingInfo => {
    setIsLoading(true)
    const hash = getMD5hash(
      `${shippingInfo.shippingCode}${shippingInfo.clientCenterCode}${shippingInfo.destinPostalCode}`,
    )
    const params = new URLSearchParams({
      client_center_code: shippingInfo.clientCenterCode,
      hash: hash,
    }).toString()

    const url = `${process.env.REACT_APP_BACKEND_ENDPOINT}/cls/pods_b64/${shippingInfo.shippingCode}?${params}`

    try {
      const response = await authedFetch('GET', url, { responseType: 'text' })
      const base64Data = response.data.trim()

      const byteCharacters = atob(base64Data)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })

      const blobUrl = URL.createObjectURL(blob)
      window.open(blobUrl, '_blank')
    } catch (error) {
      console.error('Error fetching POD:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchAlbaran = async shippingInfo => {
    setIsLoading(true)

    const url = `${process.env.REACT_APP_BACKEND_ENDPOINT}/cls/pods/manual-scans/${shippingInfo.shippingCode}`

    try {
      const response = await authedFetch('GET', url, { responseType: 'text' })
      const base64Data = response.data.trim()

      const byteCharacters = atob(base64Data)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })

      const blobUrl = URL.createObjectURL(blob)
      window.open(blobUrl, '_blank')
    } catch (error) {
      console.error('Error fetching Albaran:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return { fetchPOD, fetchAlbaran, isLoading }
}
